import styled from '@benzinga/themetron';
import { Sun } from '@benzinga/valentyn-icons';

export const MarketUpdateIcon = styled(Sun)`
  path {
    fill: ${({ theme }) => theme.colors.foregroundInactive};
    stroke: ${({ theme }) => theme.colors.foregroundInactive};
  }
`;
